<template>
  <h3 class="text-center font-semibold text-gray-700">Motivos de descarte</h3>
  <div id="chart1" class="flex md:block justify-center">
    <apexchart
      type="donut"
      :options="options"
      :series="series"
      height="200"
      width="100%"
    />
  </div>
</template>

<script>
import VueApexCharts from "vue3-apexcharts";

export default {
  name: "PRODReportingProcessReasonsDiscard",
  components: {
    apexchart: VueApexCharts
  },
  data() {
    return {
      options: {
        chart: { type: "donut" },
        dataLabels: {
          enabled: true,
          formatter: function (val) {
            return `${this.numberWithPrecision(val, 1)}%`;
          }.bind(this),
          textAnchor: "middle",
          distributed: false,
          offsetX: 0,
          offsetY: 0,
          style: {
            fontSize: "16px",
            fontFamily: "Helvetica, Arial, sans-serif",
            fontWeight: "bold",
            colors: ["#fff"]
          },
          background: {
            enabled: false,
            foreColor: "#fff",
            padding: 4,
            borderRadius: 2,
            borderWidth: 1,
            borderColor: "#fff",
            opacity: 0.9,
            dropShadow: {
              enabled: false
            }
          },
          dropShadow: {
            enabled: false
          }
        },
        legend: { fontSize: "14px", offsetX: 50 },
        labels: this.labels,
        // theme: {
        //   monochrome: {
        //     enabled: true,
        //     color: "#CC3333",
        //     shadeTo: "light",
        //     shadeIntensity: 0.9
        //   }
        // },
        plotOptions: {
          pie: {
            expandOnClick: false,
            donut: {
              size: "50%"
            }
          }
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
                height: 380
              },
              legend: {
                position: "bottom",
                offsetX: 0
              }
            }
          }
        ],
        colors: [
          "#ef4444",
          "#f97316",
          "#84cc16",
          "#10b981",
          "#3b82f6",
          "#a855f7",
          "#f43f5e",
          "#eab308"
        ]
      }
    };
  },
  props: {
    series: { required: true },
    labels: { required: true }
  }
};
</script>
